const getters = {
    dxGridSettings: state => state.grid_settings,
}

export default getters;
